import React from "react";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import BackArrow from "../backArrow";
import OwnerPropertyViewModel from "../ShopViewModel/OwnerPropertyViewModel";
import RedoIcon from "@mui/icons-material/Redo";
import Loader from "../Loader";
import ShareModel from "../Sharemodel";
import ShareOption from "../Shareoption";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { getAsset } from "../../helpers/helper";
import { useSelector } from "react-redux";
import { MainModal } from "@/components";
import { useDeleteShopItemMutation } from "../../features/shop/shopApiSlice";
import dummyImage from "@/assets/images/dummy/no_image_placeholder.png"

const Singleaddshow = ({
  singleitemadd,
  postlink,
  navurl,
  setShows,
  shows,
  setIsloading,
  loading,
  setSingleitemadd,
}) => {
  const [showmodal, setShowmodal] = useState(0);
  const [show, setShow] = useState(0);
  const [deleteid, setDeleteid] = useState();
  const { name } = useSelector((state) => state.user);
  const location = useLocation();
  const handleShow = () => {
    setShowmodal(1);
    setItemshow(0);
  };
  const handleClosemodal = () => {
    setShow(0);
  };

  const handleClosetwo = () => setShowmodal(0);
  const [itemshow, setItemshow] = useState(1);
  const handleClose = () => setShows(false);
  const navigate = useNavigate();
  const [showshare, setShowshare] = useState(false);
  const [index, setIndex] = useState();
  const handleShowshare = () => setShowshare(true);
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };

  const [deleteShopItem] = useDeleteShopItemMutation();

  const Deleteitem = async () => {
    try {
      if (setIsloading) setIsloading(true);
      const response = await deleteShopItem(deleteid).unwrap();
      if (response.success) {
        setShows(false);
        SuccessNotify("Item Deleted Successfully");
        if (setIsloading) setIsloading(false);
      }
    } catch (e) {
      if (setIsloading) setIsloading(false);
      FailedNotify("Failed to Delete Try Again!");
    }
  };

  return (
    <>
      {shows && (
        <MainModal
          variant="deleteModal"
          show={!!shows}
          shows={!!shows}
          title="Profile"
          handleClose={handleClose}
          handleDelete={Deleteitem}
          handledelete={Deleteitem}
        />
      )}
      {show === 2 && (
        <ShareModel
          show={show}
          handleClosemodal={handleClosemodal}
          handleShowshare={handleShowshare}
        />
      )}
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />

      <Container className="mt-5">
        {itemshow && (
          <Row>
            <Col lg={11} xl={12} className="mx-auto">
              <div className=" screenHeight ">
                <div className="Form-Shadow border  ms-3 ps-0 pe-0 ms-0 me-0 pt-2 pb-2 ">
                  <Row className="ms-3 me-3  align-Items-center pt-2 pb-2">
                    <Col lg={6}>
                      <div className="ms-3">
                        <BackArrow back={postlink} />
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="d-flex justify-content-end ">
                        <button
                          className="border ps-3 pe-3 pt-1 pb-1 rounded  bg-blue text-white"
                          onClick={() => navigate(postlink)}
                        >
                          Post add
                        </button>
                      </div>
                    </Col>
                  </Row>

                  <div className=" row ps-5 pe-5 noscroll scroll-shops_2">
                    {loading === true && <Loader />}
                    {singleitemadd?.map((Items) => (
                      <div className="col-lg-3 col-xl-2 col-md-6 p-2">
                        <div className="border_2">
                          <div key={Items?.id}>
                            <div className="fix-img">
                              <img
                                className="c_img"
                                src={Items?.images?.[0] ? getAsset(Items?.images[0]) : dummyImage}
                                alt=""
                                crossOrigin="anonymous"
                                loading="lazy"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = dummyImage;
                                }}
                              />
                            </div>

                            <div className="d-flex justify-content-between ps-2 pe-2">
                              <div className="pt-1">
                                <p className="mb-0  items-card-font fw-bold">
                                  {Items?.itemname?.length > 7
                                    ? `${Items.itemname.slice(0, 7)}...`
                                    : Items?.itemname}
                                </p>
                              </div>
                              <div>
                                <button
                                  className="text-white bg-blue share_font"
                                  onClick={() => setShow(2)}
                                >
                                  Share <RedoIcon className="share_icon_f" />
                                </button>
                              </div>
                            </div>
                            <div className="d-flex justify-content-between pt-1 pb-1 ps-2 pe-2 ">
                              <div>
                                <p className="mb-0 pt-1  items-card-font font-blue">
                                  {Items?.currency?.slice(0, 3)} {Items?.price}
                                </p>
                              </div>

                              <div style={{ fontSize: "small" }}>
                                Quantity({Items?.quantity})
                              </div>
                            </div>

                            <div className="d-flex justify-content-around mb-2 mt-1 ps-2 pe-2 view-delete-main">
                              <p
                                className="mb-0 view-settingss view-btn  text-center  me-1"
                                onClick={() =>
                                  navigate(`${navurl}${Items?._id}`)
                                }
                              >
                                View
                              </p>
                              <div
                                className="mb-0 delete-settingss delete-btn "
                                onClick={() => {
                                  setShows(true);
                                  setDeleteid(Items?._id);
                                }}
                              >
                                Delete
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </>
  );
};

export default Singleaddshow;
